import React from "react";
import { twMerge } from "tailwind-merge";

type Props = React.LabelHTMLAttributes<HTMLLabelElement> & {
    children: React.ReactNode;
    controlsId: string;
};

const RadioLabel = ({ children, controlsId, ...props }: Props) => {
    return (
        <label
            {...props}
            onClick={(e) => {
                props.onClick?.(e);
                if (e.defaultPrevented) return;

                const el = document.getElementById(controlsId) as HTMLElement | null;
                el?.click();
                el?.focus();
            }}
            className={twMerge(
                '!block text-gray-900 text-sm font-medium leading-5 font-sans select-none cursor-pointer',
                props.className
            )}
        >
            {children}
        </label>
    );
};

export default RadioLabel;
